/* flow-strict */

/* eslint-disable camelcase */
/**
 * Export customer database
 * @param type,csv or html
 */
import Credentials from '/client/src/api/Credentials';
const queryString = require('query-string');

import { GET } from '/client/src/api';

export function customerDatabaseExport(type = 'csv') {
  const param = {
    format: type,
    access_token: Credentials.getToken()
  };

  const query = queryString.stringify(param);

  window.open(`${process.env.PROXY_API_HOST}1/customers/export?${query}`, '_blank');
}

export async function exportAttendees(id, schedule_id, tab =  'attendees', format = 'csv') {
  const param = $.param({
    event_schedule_id: schedule_id,
    format,
    access_token: Credentials.getToken()
  });

  let url;

  switch (tab) {
    case 'questions':
      url = `${process.env.PROXY_API_HOST}1/events/${id}/attendees_additional/export?${param}`;
      break;

    case 'payments':
      url = `${process.env.PROXY_API_HOST}1/events/${id}/orders/export?${param}`;
      break;

    case 'referrals':
      url = `${process.env.PROXY_API_HOST}1/statistics/events/${id}/referrals/export?${param}`;
      break;

    default:
      try {
        // eslint-disable-next-line max-len
        const { result: { files_parts_count, links_files } } = await GET(`${process.env.PROXY_API_HOST}/1/reports/events/${id}/attendees/export-calc?${param}`);

        if (files_parts_count === 1) {
          window.open(links_files[0], '_blank');
          return;
        }

        return links_files;
      } catch (e) {
        console.log(e);
      }
  }

  window.open(url, '_blank');
}
